module.exports = __webpack_public_path__ + "static/pic03@5xwebp-8f417bd6ec582161c56269902acfe139.webp";